import { render, staticRenderFns } from "./ovrz6.vue?vue&type=template&id=4f4c1c3c"
import script from "./ovrz6.vue?vue&type=script&lang=js"
export * from "./ovrz6.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports